import { errorToast } from '../../../../../toasts/Toasts';
const goToAssets = (navigate, link) => {
    if (link.includes('Mockups')) return errorToast('This page is not available yet');
    return navigate(link);
};

export default goToAssets;
